export function getModalDialogue(modalForm:any,fieldList: any, title: any , modelId:any): any {

  return  {
    type: "fgModalDialog",
    name: "Modal Dialog",
    icon: "fa fa-square-o",
    class: "card-default",
    config: true,
    children: [
      {
        type: "fgModalHeader",
        name: "Modal Header",
        icon: "fa fa-square-o",
        config: true,
        children: [
          {
            type: "fgword",
            subtype: "h4",
            cat: "HEADING",
            icon: "fa fa-square-o",
            name: "Heading 4",
            text: title,
            condition: {},
            isCoreConfig: true,
            category: "STATIC",
            uuid: crypto.randomUUID(),
            textAlign: "text-left",
            styles: {},
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid:crypto.randomUUID(),
        styles: {},
      },
      {
        type: "fgModalBody",
        name: "Modal Body",
        icon: "fa fa-square-o",
        config: true,
        children: modalForm,
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid: crypto.randomUUID(),
        styles: {},
        customClass: "p-3",
      },
      {
        type: "fgModalFooter",
        name: "Modal Footer",
        icon: "fa fa-square-o",
        config: true,
        children: [
          {
            type: "fgcustomcontainer",
            name: "Custom Container",
            icon: "fa fa-square-o",
            class: "card-default",
            header: true,
            heading: " some heading",
            config: true,
            children: [
              {
                type: "fgbuttonaction",
                subtype: "formaction",
                icon: "fa fa-plus",
                name: "Form Button",
                condition: {},
                isCoreConfig: true,
                category: "ACTIONS",
                uuid: crypto.randomUUID(),
                setValueConfig: {},
                messageConfigs: "aftereSubmitMessage",
                messageConfig: {},
                afterMessageConfigs: {},
                option: {
                  page: {},
                },
                customReqFieldConfig: {},
                styles: {},
                label: "Cancel",
                dynamicLabel: false,
                actionCode: "ModalClose",
                customStyle: "",
                buttonClass: "",
                customClass: "fg-tertiary-button",
                modalProperty: modelId,
                actionPurposeCode: "authorise",
              },
              {
                type: "fgDataMap",
                name: "Data Map",
                icon: "fa fa-columns",
                config: true,
                condition: {},
                isCoreConfig: true,
                children: [],
                category: "INPUT",
                uuid:crypto.randomUUID(),
                mappings: fieldList,
                toBeClearFields: fieldList,
                styles: {},
                containerField: modelId,
                manualApiKey: true,
                mappingField: "MOD_WEIGHT",
                isManualBindingKey: true,
                clearAfterApply: true,
                manualApiKeyClearingField: true,
                fieldTobeClear: "MOD_WEIGHT",
                label: "Save & Close",
                customClass: "d-inline-block",
                closePopupAfterApply: true,
                isUniqueFieldEnabled: false,
                uniqueFieldKey: modelId,
                isValidate: true,
              },
              {
                type: "fgDataMap",
                name: "Data Map",
                icon: "fa fa-columns",
                config: true,
                condition: {},
                isCoreConfig: true,
                children: [],
                category: "INPUT",
                uuid:crypto.randomUUID(),
                mappings: fieldList,
                toBeClearFields: [],
                styles: {},
                containerField:modelId,
                manualApiKey: true,
                mappingField: "MOD_WEIGHT",
                isManualBindingKey: true,
                clearAfterApply: false,
                manualApiKeyClearingField: true,
                fieldTobeClear: "MOD_PESSIMISTIC",
                label: "Save & Seed",
                customClass: "d-inline-block",
                isUniqueFieldEnabled: false,
                uniqueFieldKey: modelId,
                isValidate: true,
              },
            ],
            condition: {},
            isCoreConfig: true,
            category: "LAYOUT",
            uuid:crypto.randomUUID(),
            displayContainer: "CONTAINER_FLUID",
            styles: {},
            textAlign: "END",
          },
        ],
        condition: {},
        isCoreConfig: true,
        category: "GENERAL",
        uuid: crypto.randomUUID(),
      },
    ],
    condition: {},
    isCoreConfig: true,
    category: "GENERAL",
    uuid: crypto.randomUUID(),
    toBeClearFields: [],
    styles: {
      "min-width": "800px",
    },
    modelId: modelId,
    disablePopupClose: true,
    ignoreFormData: false,
    customClass: "p-0",

  };
}
